import { useCallback } from "react";

import { PropallyApiFactory } from "@/module/CustomApiFactory";

export const useUpdateAssessmentRead = () => {
  const fp = PropallyApiFactory();

  const updateAssessmentReadById = useCallback(
    async (id: number) => {
      try {
        const res =
          await fp.v1AssessmentProposalsAssessmentProposalIdReadPatch(id, {
            withCredentials: true,
          });
        if (res.status === 200) {
          console.log("read assessment proposals", res.data);
        }

        // MEMO: 最適化のため未読数の再取得は行わない
        // オファー一覧再取得（呼び出し側）で未読件数を再計算してRecoilへ反映する
        // const unreadRes = await fp.v1AssessmentProposalUnreadCountGet({
        //   withCredentials: true,
        // });
        // setAssessmentUnreadCount(unreadRes.data as { unread_count: number });
      } catch (e) {
        console.error(e);
      }
    },
    [fp]
  );

  return updateAssessmentReadById;
};
